import React, { useEffect } from 'react'
import { IdentityDocument } from '../../../services/api/documents'
import { Passport } from './Passport'
import { BirthCertificate } from './BirthCertificate'
import { AlienPassport } from './AlienPassport'
import { InternationalPassport } from './InternationalPassport'
import {
  Passport as PassportData,
  BirthCertificate as BirthCertificateData,
  AlienPassport as AlienPassportData,
  InternationalPassport as InternationalPassportData,
} from '../../../services/api/documents'
import { Space } from 'antd'
import { useEmployeeDocuments } from '../../../services/api/employees'
import { AsyncStates } from '../../../components'

const itemStyle = {
  display: 'inline-block',
  minWidth: '300px',
  minHeight: '240px',
}
type Props = {
  employeeId: string
}

export const Documents: React.FunctionComponent<Props> = ({ employeeId }) => {
  const [getDocuments, { isLoading, response, error }] = useEmployeeDocuments(
    employeeId
  )

  useEffect(() => {
    getDocuments()
  }, [getDocuments])

  return (
    <AsyncStates<IdentityDocument[]>
      isLoading={isLoading}
      error={error}
      errorMessage="Не удалось документы пользователя"
      reload={() => getDocuments()}
      response={response}
      renderData={(documents) => (
        <Space align="start" size={10} style={{ flexWrap: 'wrap' }}>
          {documents.map(({ id, reference, type }) => (
            <div key={id}>
              {type === 'Passport' && (
                <Passport {...(reference as PassportData)} style={itemStyle} />
              )}
              {type === 'BirthCertificate' && (
                <BirthCertificate
                  {...(reference as BirthCertificateData)}
                  style={itemStyle}
                />
              )}
              {type === 'AlienPassport' && (
                <AlienPassport
                  {...(reference as AlienPassportData)}
                  style={itemStyle}
                />
              )}
              {type === 'InternationalPassport' && (
                <InternationalPassport
                  {...(reference as InternationalPassportData)}
                  style={itemStyle}
                />
              )}
            </div>
          ))}
        </Space>
      )}
    />
  )
}
